import { render, staticRenderFns } from "./PosAccount.vue?vue&type=template&id=76b827a8&"
import script from "./PosAccount.vue?vue&type=script&lang=js&"
export * from "./PosAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports